import { render, staticRenderFns } from "./visitSellInDetail.vue?vue&type=template&id=abf33cd4&scoped=true"
import script from "./visitSellInDetail.vue?vue&type=script&lang=js"
export * from "./visitSellInDetail.vue?vue&type=script&lang=js"
import style0 from "./visitSellInDetail.vue?vue&type=style&index=0&id=abf33cd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf33cd4",
  null
  
)

export default component.exports